import { Button } from '@/components/ui/button'
import { DeclarationReadinessProgress } from '@/v2/components/product-compliance-briefing/DeclarationReadinessProgress'
import type { EmcProductComplianceFileDeclarationOfConformityRequirement } from '@/v2/lib/emcProductComplianceFileDeclarationOfConformityRequirements'
import type { EmcBriefingStep } from '../../utils/emcLegislationBriefing'
import { V2EmcLegislationBriefingStepShell } from './V2EmcLegislationBriefingStepShell'

export function V2EmcEuDeclarationStep({
  step,
  index,
  declarationLabel,
  declarationEvaluation,
  onOpenDeclarationDialog,
}: {
  step: EmcBriefingStep
  index: number
  declarationLabel: string
  declarationEvaluation: {
    requirements: EmcProductComplianceFileDeclarationOfConformityRequirement[]
    generateReady: boolean
  } | null
  onOpenDeclarationDialog: () => void
}) {
  const showReadiness =
    step.status !== 'done' && declarationEvaluation != null
  const showGenerateAction = declarationEvaluation != null

  return (
    <V2EmcLegislationBriefingStepShell
      step={step}
      index={index}
      actions={
        showGenerateAction ? (
          <Button
            type='button'
            size='sm'
            variant='outline'
            onClick={onOpenDeclarationDialog}
          >
            {declarationLabel}
          </Button>
        ) : undefined
      }
    >
      {showReadiness ? (
        <DeclarationReadinessProgress
          requirements={declarationEvaluation.requirements}
          generateReady={declarationEvaluation.generateReady}
          labelKey='v2.pages.products.detail.emcBriefing.declarationReadiness.label'
          readyHintKey='v2.pages.products.detail.emcBriefing.declarationReadiness.readyHint'
        />
      ) : null}
    </V2EmcLegislationBriefingStepShell>
  )
}
